@if (item) {
    <div class="parcel-tile" (click)="navigateToParcel.emit(item.parcelID)">
        <div class="well position-relative">
            @if (item.activityStatusID !== 2) {
                <img [src]="item.activityStatusID === 0 ? '/images/inactive.jpg' : '/images/active-pending.jpg'"
                     alt="Inactive"
                     class="img-responsive parcel-tile-inactive">
            }
            <div class="parcel-tile-info">
                <parcel-icon [parcel]="item"
                             size="large"
                             [includeIcons]="true"
                             [ppReturnPreparationAllowed]="ppReturnPreparationAllowed"
                             [stateAllowConsolidating]="stateAllowConsolidating">
                </parcel-icon>
                <div class="parcel-tile-acct-num">
                    <span [ngClass]="{ 'hide-year': (item.acctNum && item.acctNum.length >= 20) }">{{ item.acctNum }}</span>
                </div>
                @if (item.annualYear) {
                    <div class="parcel-tile-year">{{ item.annualYear }}</div>
                }
            </div>
            <div class="description" [ngClass]="{ 'invisible': !item.description }">{{ item.description || 'dummy' }}</div>
            <div class="parcel-tile-data-wrapper">
                @if (item.totalFMV != null || item.isExternalReportingParcel === true) {
                    <table class="parcel-tile-data">
                        @if (item.isExternalReportingParcel !== true) {
                            <tr class="main-row"
                                [ngClass]="{ 'not-actual': ((item.status == null || item.status === 0) && item.consolidatingTypeId !== 2) }">
                                <td style="position: relative;">
                                    <strong>Total MV:</strong>
                                    @if (!item.isFmvInclude) {
                                        <span class="fa-stack"
                                              title="FMV excluded from site analysis"
                                              style="position: absolute; bottom: -7px;">
                                            <i class="fa fa-stack-1x" style="font-weight: bold;">Σ</i>
                                            <i class="fa fa-ban fa-stack-2x text-danger fa-flip-horizontal"></i>
                                        </span>
                                    }
                                </td>
                                <td>{{ (item.consolidatingTypeId !== 2 ? (item.totalFMV | number: '1.0-0') : 'N/A') }}</td>
                                <td>
                                    @if (item.fmvChange !== 0) {
                                        <span style="white-space: nowrap;"
                                              [ngClass]="{ 'increase': item.fmvChange > 0, 'decrease': item.fmvChange < 0 }">
                                            @if (item.fmvChange !== 0) {
                                                <i class="fa"
                                                   [ngClass]="{ 'fa-arrow-up': item.fmvChange > 0, 'fa-arrow-down': item.fmvChange < 0 }"></i>
                                            } {{ item.fmvChange | number }}
                                        </span>
                                    }
                                </td>
                            </tr>
                        }
                        @if (item.isExternalReportingParcel !== true) {
                            <tr [ngClass]="{'not-actual': item.status === 0}">
                                <td colspan="2" class="p-0">
                                    <div class="components-wrapper">
                                        @if (item.components && item.components.length) {
                                            <table class="components float-end">
                                                @for (component of item.components; track component) {
                                                    <tr>
                                                        <td><strong>{{ component.componentName }}:</strong></td>
                                                        <td class="p-0">{{ component.fairMarketValue | number }}</td>
                                                    </tr>
                                                }
                                            </table>
                                        }
                                    </div>
                                </td>
                            </tr>
                        }
                        @if (item.parcelsHaveCap) {
                            <tr class="main-row">
                                <td>
                                    <strong [ngClass]="{ 'hidden': !item.capValue }">Cap:</strong>
                                </td>
                                <td>{{ item.capValue | number: '1.0-0' }}</td>
                                <td></td>
                            </tr>
                        }
                        @if (item.parcelsHaveTaxable) {
                            <tr class="main-row">
                                <td>
                                    <strong helpTooltip
                                            [hasIcon]="true"
                                            [contentComponent]="taxableValueTooltip"
                                            [contentComponentValue]="{ taxableValues: item.taxableValues }"
                                            [helpDisabled]="item.taxableValues.length < 2"
                                            [ngClass]="{ 'hidden': !item.taxableValues?.length }">
                                        Taxable{{ item.taxableValues?.[0]?.description?.trim() ? ' (' + item.taxableValues[0].description.trim() + ')' : '' }}:
                                    </strong>
                                </td>
                                <td>{{ (item.taxableValues?.length ? item.taxableValues[0].fairMarketValue : null) | number: '1.0-0' }}</td>
                                <td></td>
                            </tr>
                        }
                        @if (item.isExternalReportingParcel !== true) {
                            <tr class="main-row"
                                [ngClass]="{ 'tax-is-estimated': item.taxIsEstimated != false && item.consolidatingTypeId !== 2 }">
                                <td><strong>Taxes:</strong></td>
                                @if (item.consolidatingTypeId !== 2) {
                                    <td>${{ item.totalTaxes | number: '1.2' }}</td>
                                }
                                @if (item.consolidatingTypeId === 2) {
                                    <td>N/A</td>
                                }
                                <td>
                                    @if (item.taxPercentDiff && item.taxPercentDiff !== 0) {
                                        <span style="white-space: nowrap;"
                                              [ngClass]="{ 'increase': item.taxPercentDiff > 0, 'decrease': item.taxPercentDiff < 0 }">
                                            <i class="fa"
                                               [ngClass]="{ 'fa-arrow-up': item.taxPercentDiff > 0, 'fa-arrow-down': item.taxPercentDiff < 0 }"></i> {{ item.taxPercentDiff | percent: '1.3' }}
                                        </span>
                                    }
                                </td>
                            </tr>
                        }
                        @if (item.isExternalReportingParcel === true) {
                            <tr>
                                <td style="white-space: normal; text-align: left;">This site's assets are reported on a
                                    parcel under another site. Click here to navigate to the reporting parcel.
                                </td>
                            </tr>
                        }
                    </table>
                }
            </div>
        </div>
    </div>
}
